import { render } from "./CheckIconWhite.vue?vue&type=template&id=60f5a5e5"
import script from "./CheckIconWhite.vue?vue&type=script&lang=js"
export * from "./CheckIconWhite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__